// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error--reason[data-v-7734527f]{font-weight:400 !important;margin-top:16px;padding:8px 16px;background-color:#ffdcd1;border-radius:8px}.error--reason p[data-v-7734527f]{margin:0 !important;font-size:20px !important}", ""]);
// Exports
module.exports = exports;
